import { HttpClient } from '@angular/common/http';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { TranslatesService } from 'src/shared/translates';
import { InitializedService } from 'src/shared/services/helpers/initialized.service';

export function HttpLoaderFactory(http: HttpClient) {
    return new TranslateHttpLoader(http, 'assets/i18n/', '.json');
}

export function initLanguage(translateService: TranslatesService): Function {
	return (): Promise<any> => translateService.initLanguage();
}

export function initData(initializedService: InitializedService): Function {
	return (): Promise<any> => initializedService.initData();
}
